<header class="header-auto guides">
    <div class="container-m">
      <div data-w-id="93bf799c-7678-2d76-c5ec-d119408867ce" class="topline-wrapper b-30px c-center">
        <div class="text-topline">Our Guide</div>
        <div class="topline-line bg-primary c-center"></div>
      </div>
      <div class="content-wrapper">
        <h1 data-w-id="93bf799c-7678-2d76-c5ec-d119408867d3" class="h1 l-center">YOUR ESSENTIAL GUIDE TO THE CITY</h1>
      </div>
    </div>
    <div class="container-l"></div>
    <div class="bg-section bg-background"></div>
</header>
<section class="section standard">
<div class="container-m">
    <div class="container-m">
        <div class="collection-list-wrapper t-40px w-dyn-list">
            <div role="list" class="collection-grid _3er-blog w-dyn-items">
              <div *ngFor="let guide of allBlogList" role="listitem" class="collection-item w-dyn-item">
                <a  [routerLink]="['/guide', guide.id]" class="collection-link blog-link w-inline-block">
                  <div class="image-wrapper h-250px overflow-hidden-blog"><img src="{{guide.mediaUri}}" loading="lazy" alt="" class="image full-screen"></div>
                  <div class="box blog-normal">
                    <div class="orga">
                      <div class="box-inner-02">
                        <div class="blog-wrapper b-20px">
                          <div class="properties-content">
                            <div class="blog-time-wrapper">
                              <p class="text-blog text-default">{{guide.blogDate | date:'MMM dd, yyyy'}}</p>
                            </div>
                            <p class="text-blog text-default">•</p>
                            <div class="blog-category-wrapper">
                              <p class="text-blog text-primary">{{guide.blogPlace}}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="box-inner-01">
                        <h5 class="h5 blog-h">{{guide.blogTitle}}</h5>
                      </div>
                    </div>
                    <div class="button-wrapper t-blog">
                      <div class="button button-primary">
                        <div>Read more</div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
    </div>
</div>
<div class="bg-section bg-light bg-rounded-top"></div>
</section>